import { getOptionalEnv } from './lib/getEnv';

// Use the optional getter so missing `VITE_ORN_ENV` falls through to `'dev'`.
// The required `getEnv` helper throws on a missing value, which would make
// the `?? 'dev'` clause dead code and break unit tests that import this file
// transitively without seeding `import.meta.env`.
export const ORN_ENV = getOptionalEnv('VITE_ORN_ENV') ?? 'dev';

export const IS_TEST = ORN_ENV === 'test';
export const IS_DEV = ORN_ENV === 'dev';
export const IS_STAGING = ORN_ENV === 'staging';
export const IS_PROD = ORN_ENV === 'prod';
